import DownloadPopup from "components/core/modal-components/DownloadPopup";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import { downloadOptionPdf, type, ymdDateFormat } from "utils/constants";
import { rpType } from "utils/constants/container-processing/RunPrepConstants";
import {
  getUserName,
  handleSystemErrorDataDogLog,
  printReport
} from "utils/helpers";

export default function DownloadReportModal({
  downloadReportModal,
  setDownloadReportModal,
  setIsLoading,
  throwError,
  setThrowError,
  throwErrorMessage,
  setThrowErrorMessage,
  runId,
  selectedServiceDate,
  reportType,
  handleFind,
  runPrepUpdateStatus,
  runStatus,
  tableData,
  runData,
  reportCFUrl,
  setReportCFUrl
}) {
  const { auth, currentBranch } = useSelector(selectAuth);
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);

  //handle download
  const handleDownload = async () => {
    try {
      setIsLoading(true);
      setThrowError(false);
      const reqBody = JSON.stringify({
        main_district_id: currentBranch?.district_id,
        district_id: currentBranch?.district_id,
        run_id: runId,
        run_date:
          typeof selectedServiceDate === type.string
            ? selectedServiceDate
            : selectedServiceDate?.format(ymdDateFormat),
        district_name: currentBranch?.name,
        user_name: getUserName(auth?.user),
        report_format: selectedValue?.type?.toUpperCase()
      });
      let reportResponse = await printReport(
        reqBody,
        reportType === rpType.runReport
          ? `${CF_URLS.printReports.containerProcessing.runPrep.getmediarunreport}`
          : `${CF_URLS.printReports.containerProcessing.runPrep.runreport}`
      );
      if (!reportResponse.success) {
        setThrowErrorMessage(reportResponse.error);
        setThrowError(true);
        setDownloadReportModal(false);
      } else {
        if (runData?.requests_on_run !== "0") {
          if (tableData?.length === 0) {
            await runPrepUpdateStatus();
          }
        }
        handleFind();
      }
    } catch (e) {
      let message = handleSystemErrorDataDogLog(e);
      setDownloadReportModal(false);
      setThrowErrorMessage(message);
      setThrowError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setThrowError(false);
    setDownloadReportModal(false);
    setReportCFUrl("");
  };

  return (
    <DownloadPopup
      title={t("common.downloadReport")}
      showPrintModal={downloadReportModal}
      cfUrl={reportCFUrl}
      onCancleClick={handleCancel}
      onDownloadClick={handleDownload}
      setSelectedValue={setSelectedValue}
      setThrowError={setThrowError}
      throwError={throwError}
      throwErrorMessage={throwErrorMessage}
    />
  );
}
